import React, { useState } from "react";
import { SellerPaymentMethod } from "types";
import { useSeller } from "../../../hooks/useAccount";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { EditPaymentMethodModal } from "./EditPaymentMethodModal";
import { PaymentMethodItem } from "./PaymentMethodItem";

export const CustomPaymentList = () => {
    const seller = useSeller();
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<SellerPaymentMethod | null>(null);

    const handleAddPaymentMethod = () => {
        setShowEditModal(true);
    };

    const handleClosePaymentMethodModal = () => {
        setSelectedPaymentMethod(null);
        setShowEditModal(false);
    };

    const handleEdit = (paymentMethod: SellerPaymentMethod) => {
        setSelectedPaymentMethod(paymentMethod);
        setShowEditModal(true);
    };

    const paymentMethods = seller.paymentMethods?.filter((method) => !method.deletedAt) ?? [];

    return (
        <div className="space-y-8">
            <div className="space-y-2">
                {paymentMethods.map((method) => (
                    <PaymentMethodItem key={method.id} paymentMethod={method} onEdit={handleEdit} />
                ))}

                <SecondaryButton size="small" onClick={handleAddPaymentMethod}>
                    Add Custom Payment Method
                </SecondaryButton>
            </div>

            <EditPaymentMethodModal
                isOpen={showEditModal}
                paymentMethod={selectedPaymentMethod ?? undefined}
                onClose={handleClosePaymentMethodModal}
            />
        </div>
    );
};
